export const environment = {
  production: true,
  apiUrl: "https://api.tboxfit.com",
  cdnUrl: "https://cdn.tboxfit.com",
};
